export enum EFirestoreAsyncActionType {
    GetPayrollTime,
    LockPayrollTime,
    UnLockPayrollTime,
    ClosePayrollTime,
    ExportPayrollTime,
    DownloadPayrollTimeFile,
    DownloadPayrollTimeReport,
    EmployeeLockPayrollTime,
    EmployeeUnLockPayrollTime,
    PunchDetailReport,
}